// Segmentos de negócio do ERP (mesmos identificadores do cadastro e de plans.segment no backend).
export const PLAN_SEGMENTS = [
    { value: 'bussiness', label: 'Comércio' },
    { value: 'assistance', label: 'Assistência Técnica' },
    { value: 'workshop', label: 'Oficina Mecânica' },
];

// Rótulo do segmento; vazio/nulo = plano genérico, válido para todos os segmentos.
export const planSegmentLabel = (segment) => {
    if (!segment) return 'Todos os segmentos';
    return PLAN_SEGMENTS.find((s) => s.value === segment)?.label || segment;
};
